import BaseContainer from "@base/container/BaseContainer";
import {Signals} from "@/Imports";
import * as PIXI from "pixi.js";
import Facade from "@/Facade";
import Linear from "gsap";
import {calculateTimeToMakeBets} from "@/managers/comunication/socket/utils";
import Config from "@/config/Config";
import LocalizedPIXIText from "@localisation/LocalizedPIXIText";

export default class MakeBetsContainer extends BaseContainer {

  constructor(data) {
    super(data)

    this.init()
  }

  init(data) {
    Signals.forceRoundStart.add(this.onRoundStart, this)
    Signals.roundEnd.add(this.onRoundEnd, this)
    Signals.makeBets.add(this.onMakeBets, this)

    this.o = {t: 0}
    this.isStarted = false
    this.startPos = 0
    this.multiplierScale = 0.64

    this.createProgressLogo()
    this.createText()
    this.alpha = 0
  }

  createText() {
    if (this.makeBetsText && this.makeBetsText.parent === this) {
      this.removeChild(this.makeBetsText)
      this.makeBetsText = null
    }

    const text = Facade.textFactory.getLocalizedText('makeBets')
    const style = Facade.textFactory.getStyle('makebets')
    this.makeBetsText = new LocalizedPIXIText(text, style)

    this.addChild(this.makeBetsText)
    this.makeBetsText.pivot.set((this.makeBetsText.width / 2) + 14, this.makeBetsText.height / 2)
    this.makeBetsText.y += 130
  }

  createProgressLogo() {
    this.nameLogo = 'makeBets/logo'
    this.nameEmpty = 'makeBets/empty'
    this.nameFill = 'makeBets/fill'

    this.logo = new PIXI.Sprite(PIXI.Texture.from(this.nameLogo))
    this.empty = new PIXI.Sprite(PIXI.Texture.from(this.nameEmpty))
    this.fill = new PIXI.Sprite(PIXI.Texture.from(this.nameFill))

    this.logo.scale.set(this.multiplierScale)
    this.empty.scale = this.fill.scale = this.logo.scale

    this.logo.anchor.set(0.5)
    this.empty.anchor.set(0.5)
    this.fill.anchor.set(0.5)

    this.logo.position.set(19,-9)
    this.empty.position.set(-10, 26)
    this.fill.position.set(-16, 26)

    this.progressMaskWidth = 693 * this.multiplierScale
    this.progressMaskHeight = 208 * this.multiplierScale
    this.progressMask = new PIXI.Graphics()
    this.progressMask.x = this.empty.position.x
    this.progressMask.pivot.set(0, this.progressMaskHeight / 2)
    this.progressMask.position = this.fill.position
    this.progressMask.position.x -= this.progressMaskWidth / 2
    this.progressMask.beginFill(0xffffff)
    this.progressMask.drawRect(0, 0, this.progressMaskWidth, this.progressMaskHeight)
    this.progressMask.endFill()

    this.addChild(this.empty, this.fill, this.logo)
    this.addChild(this.progressMask)

    this.fill.mask = this.progressMask
  }

  onProgress(percent) {
    this.progress = percent
  }

  set progress(value) {
    this.progressMask.scale.x = (value / 100)
  }

  onMakeBets() {
    this.createText()

    this.etalon = calculateTimeToMakeBets(Facade.model.totalTimeToMakeBets, Config.timeForExplosion)
    this.time = calculateTimeToMakeBets(Facade.model.makeBetsTime, Config.timeForExplosion)
    this.startPos = this.time < this.etalon ? 100 - ((this.time / this.etalon) * 100) : 0
    this.onProgress(this.startPos)
    TweenMax.to(this, .2, {alpha: 1})

    this.o.t = this.startPos
    TweenMax.to(this.o, this.time, {
      t: 100, ease: Linear.easeNone, onUpdate: () => {
        this.onProgress(this.o.t)
        if (this.o.t > 90 && !this.isStarted) {
          this.isStarted = true
          Signals.startPlane.dispatch()
        }
      }
    })
  }

  onRoundStart() {
    this.createText()
    TweenMax.to(this, .2, {alpha: 0})
  }

  onRoundEnd() {
    this.createText()
    this.isStarted = false
  }

}

